module.exports = __webpack_public_path__ + "img/grupoKC.9c159344.png";